import {
  BeneficiaryPerformanceType,
  TransactionItem,
} from "@/types/beneficiaries";
import { dateOptions } from "@/utils/generalUtilities";

interface TransactionsTabType {
  allTransactions: TransactionItem[];
  personalTransactions: TransactionItem[];
  employerTransactions: TransactionItem[];
}

interface BeneficiaryName {
  firstName?: string;
  lastName?: string;
}

export const useBeneficiaryTransactionsData = (
  performanceData: BeneficiaryPerformanceType,
  beneficiaryName?: BeneficiaryName
): TransactionsTabType => {
  if (
    !performanceData ||
    !performanceData.statDetails ||
    performanceData.statDetails.length === 0
  ) {
    return {
      allTransactions: [],
      personalTransactions: [],
      employerTransactions: [],
    };
  }

  const statDetails = performanceData.statDetails;

  const formatTransactionDescription = (details: string) => {
    if (beneficiaryName?.firstName && beneficiaryName?.lastName) {
      return details.replace(
        /for [A-Z0-9]+$/i,
        `for ${beneficiaryName.firstName} ${beneficiaryName.lastName}`
      );
    }
    return details;
  };

  const allTransactions: TransactionItem[] = [];
  const personalTransactions: TransactionItem[] = [];
  const employerTransactions: TransactionItem[] = [];

  statDetails.forEach((month) => {
    month.statementEntries.forEach((transaction) => {
      const valueDate = new Date(transaction.valueDate);
      const formattedDate = valueDate.toLocaleString("en-US", dateOptions);

      const details = transaction.details.toLowerCase();

      let type: "employee" | "employer" | "gift" | "other" = "other";

      if (details.includes("employee contribution")) {
        type = "employee";
      } else if (details.includes("employer contribution")) {
        type = "employer";
      } else if (details.includes("gift")) {
        type = "gift";
      } else if (details.includes("nav adjustment")) {
        return;
      }

      const transactionItem: TransactionItem = {
        date: formattedDate,
        //description: transaction.details,
        description: formatTransactionDescription(transaction.details),
        amount:
          transaction.credit > 0
            ? transaction.credit
            : Math.abs(transaction.debit),
        type: type,
        valueDate: valueDate,
      };
      allTransactions.push(transactionItem);

      if (type === "employee") {
        personalTransactions.push(transactionItem);
      } else if (type === "employer") {
        employerTransactions.push(transactionItem);
      }
    });
  });

  const sortByDate = (a: TransactionItem, b: TransactionItem) =>
    b.valueDate.getTime() - a.valueDate.getTime();

  allTransactions.sort(sortByDate);
  personalTransactions.sort(sortByDate);
  employerTransactions.sort(sortByDate);

  return {
    allTransactions,
    personalTransactions,
    employerTransactions,
  };
};
